module.exports = __webpack_public_path__ + "assets/img/row.c84e304f.png";